import React from 'react'
import { CheckCircle } from 'lucide-react'
import { useVendorDashboard } from '../VendorDashboard'

const VendorSubscription = () => {
  const { vendorData } = useVendorDashboard()

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Subscription Details</h3>
      
      <div className="bg-white dark:bg-slate-800 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h4 className="text-xl font-semibold text-gray-900 dark:text-white">{vendorData.subscription.plan} Plan</h4>
            <p className="text-gray-600 dark:text-gray-300">Current subscription</p>
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-gray-900 dark:text-white">
              ₹{vendorData.subscription.price}
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-300">
              per {vendorData.subscription.billingCycle}
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h5 className="font-medium text-gray-900 dark:text-white mb-3">Plan Benefits</h5>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {vendorData.subscription.features.map((feature, index) => (
              <div key={index} className="flex items-center">
                <CheckCircle className="w-5 h-5 text-success-500 mr-3 flex-shrink-0" />
                <span className="text-sm text-gray-700 dark:text-gray-300">{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mb-6">
          <h5 className="font-medium text-gray-900 dark:text-white mb-3">Plan Limits</h5>
          <div className="grid grid-cols-2 gap-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-600">{vendorData.subscription.limits.projects}</div>
              <div className="text-sm text-gray-600 dark:text-gray-300">Projects</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-primary-600">{vendorData.subscription.limits.profileViews}</div>
              <div className="text-sm text-gray-600 dark:text-gray-300">Profile Views</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VendorSubscription

